import React from 'react';
import { Outlet } from 'react-router-dom';

const RootLayout: React.FC = () => {
  return (
    <div className="min-h-screen relative">
      <Outlet />
    </div>
  );
};

export default RootLayout;
